require('../../../assets/lib/log4javascript/log4javascript.js');
require('../../../assets/scripts/jhire/services/jv.services.js');
require('../../../assets/scripts/candidates/jv.Candidates.LinkedIn.app.js');